import { Component } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AdministradorService } from '../../../../services/administrador.service';
import { SaldoEnfermeraFormatoXLS, SaldoEnfermeraGeneral } from '../../../../models/totales-generales.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';

@Component({
  selector: 'app-administrador-enfermeras-saldos-general',
  templateUrl: './administrador-enfermeras-saldos-general.component.html',
  styleUrls: ['./administrador-enfermeras-saldos-general.component.scss']
})
export class AdministradorEnfermerasSaldosGeneralComponent {
  currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItems: number = 10;

  saldosEnfermeras: SaldoEnfermeraGeneral[] = [];

  constructor(private administradorService: AdministradorService) {
    this.obtenerInformacion();
  }
  get totalPaginas(): number {
    return Math.ceil(this.saldosEnfermeras.length / this.currentPage.rows);
  }
  get paginacionSaldosEnfermeras(): SaldoEnfermeraGeneral[] {
    const startIndex = (this.currentPage.page) * this.currentPage.rows;
    return this.saldosEnfermeras.slice(startIndex, startIndex + this.currentPage.rows);
  }
  obtenerInformacion() {
    this.administradorService.puntosysaldosEnfermeras().subscribe({
      next: (resp) => {
        this.saldosEnfermeras = resp;
        this.totalItems = resp.length;
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
      }
    })
  }
  onPageChange(event: any) {
    this.currentPage = <Paginar>event;
  }
  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const saldosEnfermeras: SaldoEnfermeraFormatoXLS[] = this.fullSaldosEnfermeras(this.saldosEnfermeras);
    const titulo = [{ campo: "Saldos de Enfermeras ", fecha: new Date().toLocaleDateString() }];
    const fileName = 'saldos-enfermeras';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, titulo, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, saldosEnfermeras, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'saldos-enfermeras');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  fullSaldosEnfermeras(saldos: SaldoEnfermeraGeneral[]): SaldoEnfermeraFormatoXLS[] {
    const saldoEnfermeras = saldos.map((item) => { return { Enfermera: item.nomEnfermera, "Total Canje": item.totales_redimir_casosclinicos, Puntos: item.totales_puntos, Saldo: item.totales_saldo } });
    return saldoEnfermeras;
  }
}
